import clsx from "clsx";
import { useWorkspaceCurrency } from "@/api/session";
import { MISSING_VALUE, formatMoney, type NumericInput } from "@/lib/format";
import styles from "./Money.module.css";

export interface MoneyProps {
  /** Integer minor units (cents), as the API sends `price_minor`. */
  minor: NumericInput;
  /** ISO 4217; defaults to the workspace currency. */
  currency?: string;
  /** Extra decimals for unit prices, e.g. 2 for a price per gram. */
  extraDecimals?: number;
  /** A unit after the amount: "g" renders "CA$0.1250 / g". */
  per?: string;
  signDisplay?: "auto" | "always" | "exceptZero";
  className?: string;
}

/** A money amount from minor units, in the workspace currency unless given (CA$12.40). */
export function Money({ minor, currency, extraDecimals, per, signDisplay, className }: MoneyProps) {
  const workspaceCurrency = useWorkspaceCurrency();
  const text = formatMoney(minor, currency ?? workspaceCurrency, { extraDecimals, signDisplay });
  const missing = text === MISSING_VALUE;
  return (
    <span className={clsx(styles.money, className)} data-missing={missing || undefined}>
      {text}
      {per && !missing ? <span className={styles.unit}>/&nbsp;{per}</span> : null}
    </span>
  );
}
